import { createSlice } from '@reduxjs/toolkit';


const initialState = {
    quotes: [],
    selectedQuotes: null,
    filters: {
        sumAssured: 0,
        planType: "basic",
        insurer:'',
        // "high_to_low" | "low_to_high" | ""
        sortPremium: ""
},
    quoteLoading:false,
    lastFetchKey: ""
}
const QuoteDetailsSlice = createSlice({
    name: 'quoteDetails',
    initialState,
    reducers: {
        updateQuoteDetails: (state, action) => {
            Object.assign(state, action.payload);;
        },
        resetQuoteDetails: () => initialState
    }
});

export const { updateQuoteDetails, resetQuoteDetails } = QuoteDetailsSlice.actions;
export default QuoteDetailsSlice.reducer;
